(function(root){
  'use strict';
  const endsAt=Date.parse('2026-11-02T01:00:00.000Z');
  const ids=new Set(['58987123999064','58987124392280','58987124425048','58987124457816','58987125834072','58987125899608']);
  const isGift=item=>ids.has(String(item.variant_id||item.id));
  function paidQuantities(cart){
    const result={};
    for(const item of cart.items.filter(i=>!isGift(i))){
      const key=JSON.stringify([String(item.variant_id||item.id),item.selling_plan_allocation?.selling_plan?.id||null,Object.entries(item.properties||{}).sort(([a],[b])=>a.localeCompare(b))]);
      result[key]=(result[key]||0)+item.quantity;
    }
    return result;
  }
  function createCleaner(request,route='/',now=Date.now){
    let pending;
    const active=()=>now()>=endsAt;
    const json=async(url,options)=>{
      const response=await request(url,options);
      if(!response.ok)throw Error('EXPIRED_GIFT_CART_UNAVAILABLE');
      const cart=await response.json();
      if(!Array.isArray(cart.items))throw Error('EXPIRED_GIFT_INVALID_CART');
      return cart;
    };
    async function clean(){
      if(!active())return {cart:null,changed:false};
      const cart=await json(route+'cart.js',{headers:{Accept:'application/json'}});
      const gifts=cart.items.filter(isGift);
      if(!gifts.length)return {cart,changed:false};
      const before=paidQuantities(cart);
      const updates=Object.fromEntries(gifts.map(item=>[item.key,0]));
      if(gifts.some(item=>!item.key))throw Error('EXPIRED_GIFT_INVALID_KEY');
      const after=await json(route+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({updates})});
      const quantities=paidQuantities(after);
      if(after.items.some(isGift)||Object.keys(before).length!==Object.keys(quantities).length||Object.entries(before).some(([key,quantity])=>quantities[key]!==quantity))throw Error('EXPIRED_GIFT_CHANGED_PAID_CART');
      return {cart:after,changed:true};
    }
    return {get active(){return active();},sync:()=>pending||=(clean().finally(()=>{pending=null;}))};
  }
  if(typeof module!=='undefined')module.exports={createCleaner,endsAt,ids};
  if(!root?.document||!root.fetch)return;
  const cleaner=createCleaner(root.fetch.bind(root),root.Shopify?.routes?.root||'/');
  async function sync(){
    const result=await cleaner.sync();
    if(result.changed){
      // Reload indexed updates[] forms before they can submit stale line positions.
      if(/\/cart\/?$/.test(root.location.pathname)){root.location.reload();return new Promise(()=>{});}
      root.dispatchEvent(new Event('cart:updated'));
    }
    return result.cart;
  }
  root.SolsticeExpiredGifts={get active(){return cleaner.active;},sync};
  const refresh=()=>{if(cleaner.active)sync().catch(()=>{});};
  root.addEventListener('cart:updated',refresh);
  root.setTimeout(refresh,Math.max(0,endsAt-Date.now()));
  refresh();
})(typeof window==='undefined'?null:window);
